// components/ClientLink.tsx
"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import type { LinkProps } from "next/link";

type Props = LinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default function ClientLink({
  href,
  onClick,
  children,
  ...rest
}: Props) {
  // 当 pathname/search 变化时，认为导航完成 -> 隐藏进度条
  const pathname = usePathname();

  useEffect(() => {
    NProgress.done();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 启动进度条（立即）
    NProgress.start();

    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  // next/link 支持直接传 onClick / className / children 等
  return (
    <Link href={href as string} {...rest} onClick={handleClick}>
      {children}
    </Link>
  );
}
